
const app = {
  state: {
    isShowLeft: true, // 控制操作台左侧面板是否显示
    isLeftDrawVisible: false, // 左侧抽屉是否显示
    isShowRight: false, // 控制操作台右侧面板是否显示
    isRightDrawVisible: false, // 左侧抽屉是否显示
    isShowTop: true, // 操作台顶部面板是否显示
    maxZIndex: 1, // 最大UI层级
    allowDrawState: true, // 允许进入绘制状态，实际表现效果为：isDrawState 是否允许被设置值
    isDrawState: false, // 是否绘制状态
    _layerId: null, // 选中图层id
    curMapId: undefined, // 当前地图id
    isTemplate: false, // 是否模板
    uiHiddenState: {} // UI隐藏状态
  },
  mutations: {
    SHOW_LEFT: (state, isShow) => {
      state.isShowLeft = isShow
    },
    LEFT_DRAW_VISIBLE: (state, isVisible) => {
      state.isLeftDrawVisible = isVisible
    },
    RIGHT_DRAW_VISIBLE: (state, isVisible) => {
      state.isRightDrawVisible = isVisible
    },
    SHOW_RIGHT: (state, isShow) => {
      state.isShowRight = isShow
    },
    SHOW_TOP: (state, isShow) => {
      state.isShowTop = isShow
    },
    SET_ZINDEX: (state, data) => {
      state.maxZIndex = data
    },
    SET_ALLOWDRAWSTATE: (state, data) => {
      state.allowDrawState = data
    },
    SET_DRAWSTATE: (state, data) => {
      state.allowDrawState && (state.isDrawState = data)
    },
    SET_LAYERID: (state, data) => {
      state._layerId = data
    },
    SET_CURMAP: (state, data) => {
      state.curMapId = data
    },
    SET_ISTEMPLATE: (state, data) => {
      state.isTemplate = data
    },
    SET_UI_HIDDEN_STATE: (state, data) => {
      state.uiHiddenState = data
      console.log('uiHiddenState----------', data)
    }
  },
  actions: {
    showLeft ({ commit }, isShow) {
      return new Promise((resolve, reject) => {
        commit('SHOW_LEFT', isShow)
      })
    },
    setLeftDrawVisible ({ commit }, isShow) {
      return new Promise((resolve, reject) => {
        commit('LEFT_DRAW_VISIBLE', isShow)
      })
    },
    showRight ({ commit }, isShow) {
      return new Promise((resolve, reject) => {
        commit('SHOW_RIGHT', isShow)
      })
    },
    setRightDrawVisible ({ commit }, isShow) {
      return new Promise((resolve, reject) => {
        commit('RIGHT_DRAW_VISIBLE', isShow)
      })
    },
    showTop ({ commit }, isShow) {
      return new Promise((resolve, reject) => {
        commit('SHOW_TOP', isShow)
      })
    },
    setMaxZIndex ({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_ZINDEX', data)
      })
    },
    setAllowDrawState ({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_ALLOWDRAWSTATE', data)
      })
    },
    setDrawState ({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        if (state.isDrawState === !!data || !state.allowDrawState) {
          return
        }
        commit('SET_DRAWSTATE', data)
        if (data === true) {
          state._lastLeftVisible = !!state.isLeftDrawVisible
          state._lastRightVisible = !!state.isRightDrawVisible
          commit('SHOW_LEFT', false)
          commit('SHOW_RIGHT', false)
        } else {
          commit('SHOW_LEFT', state._lastLeftVisible)
          commit('SHOW_RIGHT', state._lastRightVisible)
        }
      })
    },
    setLayerId ({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_LAYERID', data)
        resolve()
      })
    },
    setCurMapId ({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_CURMAP', data)
      })
    },
    setUIHiddenState ({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_UI_HIDDEN_STATE', data)
      })
    }
  }
}

export default app
